// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"253":"f8878c1d","386":"f16c4854","505":"01d48c22","572":"31827e97","693":"9e7d6130","827":"44c91d46","897":"b214d620","979":"d4383192","981":"346efa23"}[chunkId] + ".chunk.js";
};